<template>
  <v-list-group id="menu_group" :prepend-icon="icon" class="v-list-item">
    <template slot="activator">
      <v-list-tile class="group-tile">
        <v-list-tile-content class="group-tile-content">
          <v-list-tile-title class="group-tile-title">  &nbsp;&nbsp;&nbsp;&nbsp; {{text}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>

    <v-list-tile
      v-for="(link, i) in links"
      :key="i"
      :to="link.to"
      :active-class="color"
      avatar
      class="v-list-item"
    >
      <v-list-tile-action>
        <v-icon v-if="link.icon">{{ link.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-title v-text="link.text" />
    </v-list-tile>
    
  </v-list-group>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  props: ["to", "active_class", "text", "icon", "links"],
  computed: {
    ...mapState("app", ["image", "color"]),
    // cLinks() {
    //   return this.links.filter( el => {
    //     return this.$can('read', el.entity || 'all' )
    //   })
    // }
  }
};
</script>

<style  lang="scss">
#menu_group {
  .group-tile-title {
      font-size: 14px !important;
      font-weight: 300;
      padding: 0;
      margin:0;
  };
  .group-tile-content {
    margin:0;
    padding:0;
  }
   .group-tile {
     .v-list__tile {
      margin:0;
      padding:0;
    }
  }
}
</style>